<template>
    <div class="Drawer" v-show="showDrawer">
        <div @click="closeClick" class="close">
            <CloseOutlined style="color: #aaa" />
        </div>
        <div class="head">
            <div class="drawer_title">测试详情</div>
            <div class="drawer_status">
                {{
                    carInfo.onlineStatus != null ? carInfo.onlineStatus === 0 ? '离线' : carInfo.onlineStatus === 1 ? '在线' :
                        '无'
                        : '无'
                }}
            </div>
            <!-- <div class="drawer_status drawer_status_offline">离线</div> -->
        </div>
        <div class="overflow">
            <div class="drawer_main">
                <table>
                    <tr>
                        <td colspan="2" class="name">
                            基础信息
                        </td>
                    </tr>
                    <tr>
                        <td>测试牌照：{{ carInfo.testCarNum }}</td>
                        <td>车辆型号：{{ carInfo.carModel }}</td>
                    </tr>
                    <tr>
                        <td colspan="2">测试类型：
                            {{ getSingleTypeValue(appStore.SysDictVOList, dataType + "category" + carInfo.testType) }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">测试开始时间：{{ carInfo.startTimeStr }}</td>
                    </tr>
                </table>

                <table class="mt14">
                    <tr>
                        <td colspan="2" class="name">
                            测试道路
                        </td>
                    </tr>
                    <tr>
                        <td class="second">
                            {{ zoneDetails.length != 0 ? zoneDetails.join(',') : '' }}
                        </td>
                    </tr>
                </table>

                <table class="mt14">
                    <tr>
                        <td colspan="2" class="name">
                            驾驶员/安全员信息
                        </td>
                    </tr>
                    <tbody v-for="item in driverPersonArr" :key="item.phoneNum">
                        <tr>
                            <td>驾驶员：{{ item.name }}</td>
                            <td>手机号码：{{ item.phoneNum }}</td>
                        </tr>
                        <tr>
                            <td colspan="2">驾驶证号：{{ item.driverNum }}</td>
                        </tr>
                    </tbody>
                    <tbody v-for="item in securityPersonArr" :key="item.phoneNum">
                        <tr>
                            <td>安全员：{{ item.name }}</td>
                            <td>手机号码：{{ item.phoneNum }}</td>
                        </tr>
                    </tbody>
                </table>

                <table class="mt14">
                    <tr>
                        <td colspan="2" class="name">
                            监控信息
                        </td>
                    </tr>
                    <tr>
                        <td>当前速度： {{ carInfo.speed }}KM/h</td>
                        <!-- <td>最高速度：9km/h</td> -->
                        <td>航向角：{{ carInfo.headAngle }}度</td>
                    </tr>
                    <!-- <tr>
                        <td>航向角：0度</td>
                        <td></td>
                    </tr> -->
                </table>

                <!-- 模拟板 -- 实时视频 -->
                <a-tabs class="mt14" v-model:activeKey="moniActiveKey" v-if="carInfo.isDemonstrate === 1">
                    <a-tab-pane :key="0" tab="车外">
                        <!-- <img src="@/assets/images/car1.png" alt=""> -->
                        <div class="video">

                            <video class="video-area-main-body" autoplay muted loop
                                :src="moniVideoList[0] ? moniVideoList[0]?.url : ''">
                            </video>

                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="1" tab="车内" force-render>
                        <!-- <img src="@/assets/images/car2.png" alt=""> -->
                        <div class="video">

                            <video class="video-area-main-body" autoplay muted loop
                                :src="moniVideoList[1] ? moniVideoList[1]?.url : ''">
                            </video>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="2" tab="刹车踏板" force-render>
                        <!-- <img src="@/assets/images/car3.png" alt=""> -->
                        <div class="video">

                            <video class="video-area-main-body" autoplay muted loop
                                :src="moniVideoList[2] ? moniVideoList[2]?.url : ''">
                            </video>

                        </div>
                    </a-tab-pane>
                </a-tabs>

                <!-- 真实 -- 真实视频 -->
                <a-tabs class="mt14" v-model:activeKey="activeKey" v-else>
                    <a-tab-pane :key="0" tab="车外">
                        <!-- <img src="@/assets/images/car1.png" alt=""> -->
                        <div class="video">

                            <video id="video1" controls width="430" height="260"></video>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="1" tab="车内" force-render>
                        <!-- <img src="@/assets/images/car2.png" alt=""> -->
                        <div class="video">

                            <video id="video2" controls width="430" height="260"></video>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="2" tab="刹车踏板" force-render>
                        <!-- <img src="@/assets/images/car3.png" alt=""> -->
                        <div class="video">

                            <!-- <video class="video-car-main-body" autoplay muted>
                                <source :src="videoList.breakVideo" type="video/mp4">
                            </video> -->
                            <video id="video3" controls width="430" height="260"></video>
                        </div>
                    </a-tab-pane>
                </a-tabs>


            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onUnmounted, onMounted, watch, defineProps, defineEmits, defineExpose } from 'vue'
import { detailRealtimeMonitorVehicle, getCarActualVideoInfo, getListByCondition } from '@/api/test/realtimeMonitor'
import { getSingleTypeValue } from "@/utils/matchDic";
import useAppStore from "@/store/modules/app";
import flvjs from 'flv.js';
const appStore = useAppStore();

const props = defineProps({
    showDrawer: {
        type: Boolean,
        default: false
    },
    detailStatusData: {
        type: Array,
        default: () => {
            return []
        }
    },
    carMakerData: {
        type: Array,
        default: () => {
            return []
        }
    }
})


watch(
    () => props.detailStatusData,
    (val) => {
        // console.log(val);
        if (val) {
            createStatus(val)
            // addPolylines(val)
            // selectedMarker(val)
        }
    },
    { deep: true }
)

watch(
    () => props.carMakerData,
    (val) => {
        // console.log(val);
        if (val) {
            createSpeend(val)
            // addPolylines(val)
            // selectedMarker(val)
        }
    },
    { deep: true }
)
// 实时视频 tab
const activeKey = ref(0);
// 模拟板 -- 实时视频tab
const moniActiveKey = ref(0)
const moniVideoList = ref([])

const player = ref(null)


const dataType = "testType";

const carInfo = ref({
    testCarNum: '',
    carModel: '',
    testType: '',
    startTimeStr: '',
    onlineStatus: null,
    speed: '0',
    headAngle: '0',
})

const emits = defineEmits(['closeEvet'])
const closeClick = () => {
    if (player.value) {
        player.value.destroy();
    }
    emits('closeEvet', 111)
}

const zoneDetails = ref([])
const driverPersonArr = ref([])
const securityPersonArr = ref([])
const infoStatus = ref('')

//点击 表格 调接口 渲染drawer 数据
const startMonitor = (info) => {
    console.log(info);
    infoStatus.value = info.frameNum
    driverPersonArr.value = []
    securityPersonArr.value = []
    detailRealtimeMonitorVehicle({ id: info.id }).then(res => {
        console.log(res);
        if (res.code === 200) {
            carInfo.value = res.data.carInfo
            zoneDetails.value = res.data.zoneDetails
            res.data.personInfo.map(item => {
                if (item.personType.includes('driver')) {
                    driverPersonArr.value.push(item)
                }
                if (item.personType.includes('security')) {
                    securityPersonArr.value.push(item)
                }
            })

        }
    })
}


const videoList = ref({})
const outVideo = ref('')
const inVideo = ref('')
const breakVideo = ref('')

//点击 表格 调用 实时视频 接口
const getCarActualVideoInfoData = (info) => {
    getCarActualVideoInfo(info.frameNum, info.monitorDeviceId).then(res => {
        if (player.value) {
            console.log(player.value);
            player.value.destroy();
            player.value = null
        }
        activeKey.value = 0
        outVideo.value = ''
        inVideo.value = ''
        breakVideo.value = ''
        console.log(res);
        if (res.code === 200) {
            if (res.data) {
                // videoList.value = res.data
                if (res.data.outVideo) {
                    outVideo.value = res.data.outVideo
                    getVideoUrl('/live' + res.data.outVideo.split('/live')[1], 'video1')
                }
                if (res.data.inVideo) {
                    inVideo.value = res.data.inVideo
                }
                if (res.data.breakVideo) {
                    breakVideo.value = res.data.breakVideo
                }
            }
        }
    })
}

// 模拟版 --  点击 表格 调用 实时视频 接口
const getMoniCarInfo = () => {
    let data = {
        "funcCode": "monitor_camera_url"
    }
    getListByCondition(data).then(res => {
        if (res.code === 200) {
            console.log(res);
            moniActiveKey.value = 0
            moniVideoList.value = res.data
        }
    })
}



watch(() => activeKey.value, (newTab) => {
    console.log(newTab);
    if (player.value) {
        player.value.destroy();
    }
    if (newTab === 0) {
        if (outVideo.value) {
            getVideoUrl('/live' + outVideo.value.split('/live')[1], 'video1')
        }
    } else if (newTab === 1) {
        if (inVideo.value) {
            getVideoUrl('/live' + inVideo.value.split('/live')[1], 'video2')
        }
    } else if (newTab === 2) {
        if (breakVideo.value) {
            getVideoUrl('/live' + breakVideo.value.split('/live')[1], 'video3')
        }

    }
});

const getVideoUrl = (url, id) => {
    console.log(url);
    console.log(id);
    const videoElement = document.querySelector(`#${id}`);
    console.log(videoElement);
    if (videoElement) {
        player.value = flvjs.createPlayer({
            type: 'flv',
            url: url
        });
        player.value.attachMediaElement(videoElement);
        player.value.load();
        player.value.play();
    }


}


const createStatus = (detailInfos) => {
    console.log(detailInfos);
    if (infoStatus.value !== '') {
        let info = detailInfos.filter(item => item.frameNum === infoStatus.value)
        if (info.length > 0) {
            carInfo.value.onlineStatus = info[info.length - 1].status
        }
    }
    // console.log(carInfo.value);
}
const createSpeend = (detailInfos) => {
    // console.log(detailInfos);
    if (infoStatus.value !== '') {
        let info = detailInfos.filter(item => item.frameNum === infoStatus.value)
        if (info.length > 0) {
            carInfo.value.speed = info[info.length - 1].speed
            carInfo.value.headAngle = info[info.length - 1].headAngle
        }
    }
    // console.log(carInfo.value);
}




onUnmounted(() => {
    // if (player.value) {
    //     player.value.pause(); // 暂停视频播放
    //     player.value.unload(); // 卸载视频流
    //     player.value.detachMediaElement(); // 断开视频元素关联
    //     player.value.destroy(); // 销毁播放器实例
    //     player.value = null; // 设置为null，避免内存泄露
    // }
    if (player.value) {
        player.value.destroy();
    }
})

defineExpose({ startMonitor, getCarActualVideoInfoData, carInfo, getMoniCarInfo })

</script>
<style lang="less" scoped>
.close {
    display: flex;
    justify-content: end;
    padding: 16px 16px 0 0;
    cursor: pointer;
}

.Drawer {
    width: 475px;
    height: 92.3vh;
    background: #FFFFFF;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.25);
    opacity: 1;

    .overflow {
        height: 82vh;
        overflow: hidden;
        overflow-y: auto;
    }

    .head {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .drawer_title {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            color: #1D2129;
            position: relative;
            padding: 22px 0 19px 23px;

            &::before {
                content: '';
                display: inline-block;
                width: 3px;
                height: 12px;
                background: #1E8EF2;
                border-radius: 10px;
                position: absolute;
                top: 24px;
                left: 13px;
            }
        }

        .drawer_status {
            width: 64px;
            height: 25px;
            background: #1BCB61;
            border-radius: 17px 17px 17px 17px;
            text-align: center;
            line-height: 25px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            margin-right: 16px;
        }

        .drawer_status_offline {
            background: rgb(242, 179, 184);
        }
    }

    .drawer_main {
        padding: 0 20px;

        table {
            width: 100%;

            td {
                border: 1px solid #E1E7EF;
                padding: 17px 0 11px 28px;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #636D7B;
                text-align: left;
            }

            .name {
                background: #F6F8FA;
                padding: 11px 0 9px 28px;
                text-align: left;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                color: #1D2129;
                border-left: 1px solid #F6F8FA;
                border-right: 1px solid #F6F8FA;
                border-top: none;
            }

            .table_action {
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #186FF2;
            }
        }
    }

    .second {
        padding: 17px 0 15px 28px !important;
        line-height: 19px;
    }

    .video {
        width: 432px;
        height: 241px;
        // border: 1px solid #000000;

        .video-car-main-body {
            width: 100%;
            // height: 241px;
        }
    }
}

.video-area-main-body {
    width: 100%;
    // height: 241px;
}

.mt14 {
    margin-top: 14px;
}

/deep/.ant-tabs .ant-tabs-tab {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: rgba(29, 33, 41, 0.7);
    margin: 0 0 0 70px;
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #1D2129;
}



/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
    // background: #1E8EF2;
    // background: rgba(30, 142, 242, 1);
}
</style>
